module.exports = __webpack_public_path__ + "img/background_medio_pc.2aa4083e.png";